var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',{staticStyle:{"height":"7%","padding":"0"}},[_vm._t("panel-top")],2),_c('el-main',{staticStyle:{"height":"93%","padding":"0 20px"}},[_vm._t("panel-main")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }